import { Box, Flex, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  header: string;
  name: string;
  onClick?: () => void;
};

export function SuggestedActionCard({ header, name, onClick }: Props) {
  return (
    <Box
      bg="brand.1"
      p="xs"
      style={{ width: 209, borderRadius: 12, cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      <Text size="textXs" fw={FONT_WEIGHTS.medium} c="brand.6">
        {header}
      </Text>
      <Flex justify="space-between" align="center" gap="sm" mt="xxxs">
        <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.10">
          {name}
        </Text>
        <IconChevronRight
          size={16}
          color="var(--mantine-color-gray-10)"
          style={{ flexShrink: 0 }}
        />
      </Flex>
    </Box>
  );
}
